export const SESSION_MY_HOME_TOOLTIP_KEY = 'my_home_tooltip_key';
